import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SiaBaseActionService {
  visibilityActions: any = {};
  visibilityActionsSubject: Subject<any> = new Subject<any>();

  templateActions: any = {};
  templateActionsSubject: Subject<any> = new Subject<any>();

  disabledActions: any = {};
  disabledActionsSubject: Subject<any> = new Subject<any>();

  actionBadges: any = {};
  badgeActionsSubject: Subject<any> = new Subject<any>();

  constructor() {}

  /**
   * Rimuove una action dalla lista delle action visibili
   * @param componentId il componente al quale viene nascosta la action
   * @param guid il guid al relativo al component al quale viene nascosta l'azione
   * @param actionId l'id dell'action da nascondere
   * @param visible se true, l'action viene mostrata, altrimenti nascosta
   */
  handleAction(
    componentId: string,
    guid: string,
    actionId: string,
    visible: boolean,
  ) {
    if (componentId && guid && actionId) {
      if (this.visibilityActions[guid] == undefined) {
        this.visibilityActions[guid] = {};
      }
      if (this.visibilityActions[guid][componentId] == undefined) {
        this.visibilityActions[guid][componentId] = {};
      }
      this.visibilityActions[guid][componentId][actionId] = visible;
      this.visibilityActionsSubject.next(this.visibilityActions);
    }
  }

  disableAction(
    componentId: string | undefined,
    guid: string | undefined,
    actionId: string,
    disabled: boolean,
  ) {
    if (componentId && guid && actionId) {
      if (this.disabledActions[guid] == undefined) {
        this.disabledActions[guid] = {};
      }
      if (this.disabledActions[guid][componentId] == undefined) {
        this.disabledActions[guid][componentId] = {};
      }
      this.disabledActions[guid][componentId][actionId] = disabled;
      this.disabledActionsSubject.next(this.disabledActions);
    }
  }

  assignActionTemplate(
    componentId: string,
    guid: string,
    actionId: string,
    template?: TemplateRef<any>,
  ) {
    if (componentId && guid && actionId) {
      if (this.templateActions[guid] == undefined) {
        this.templateActions[guid] = {};
      }
      if (this.templateActions[guid][componentId] == undefined) {
        this.templateActions[guid][componentId] = {};
      }
      this.templateActions[guid][componentId][actionId] = template;
      this.templateActionsSubject.next(this.templateActions);
    }
  }

  showActionBadge(
    componentId: string,
    guid: string,
    actionId: string,
    visible: boolean,
  ) {
    if (componentId && actionId && guid) {
      if (this.actionBadges[guid] == undefined) {
        this.actionBadges[guid] = {};
      }
      if (this.actionBadges[guid][componentId] == undefined) {
        this.actionBadges[guid][componentId] = {};
      }
      this.actionBadges[guid][componentId][actionId] = visible;
      this.badgeActionsSubject.next(this.actionBadges);
    }
  }
}
